<app-banner-item *ngFor="let banner of banners" [banner]="banner"></app-banner-item>
